import React from 'react';
import cn from 'classnames';
import { handleImageUrl } from '$/utils/image';

import styles from './index.module.scss';

const MATERIAL_CARD_PREVIEW_SIZE = 240;

export interface MaterialCardProps {
  cover: string;
  title: string;
  tags: string[] | null;
  coverWidth: number;
  coverHeight: number;
  selected?: boolean;
  cardRef?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
}

/**
 * 官方资产单个素材卡片，点击卡片任意区域进入详情。
 */
function MaterialCard({
  cover,
  title,
  tags,
  coverWidth,
  coverHeight,
  selected = false,
  cardRef,
  onClick,
}: MaterialCardProps): React.ReactElement {
  const coverStyle = { aspectRatio: `${coverWidth} / ${coverHeight}` };

  return (
    <button
      ref={cardRef}
      type="button"
      className={cn(styles.materialCard, { [styles.materialCardSelected]: selected })}
      onClick={onClick}
    >
      <div className={styles.materialCardCover} style={coverStyle}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className={styles.materialCardImage}
          src={handleImageUrl(cover, { size: MATERIAL_CARD_PREVIEW_SIZE })}
          alt={title}
          crossOrigin="anonymous"
        />
      </div>
      <div className={styles.materialCardInfo}>
        <p className={styles.materialCardTitle}>{title}</p>
        <div className={styles.materialCardTags}>
          {tags?.map((tag) => (
            <span key={tag} className={styles.materialCardTag}>{tag}</span>
          ))}
        </div>
      </div>
      {selected && <span className={styles.materialCardOutline} />}
    </button>
  );
}

export default MaterialCard;
